// Sidepane functionality, developed for the inspiration info content

// Initializes the sidepane functionality
function initialize() {

  const sidepaneGroupSelector = '.wf-sidepane-group';
  const sidepaneSelector = '.wf-sidepane';
  const sidepaneButtonToggleSelector = '.wf-sidepane-button-toggle';
  const sidepaneButtonCloseSelector = '.wf-sidepane-button-close';
  const sidepaneButtonCloseAllSelector = '.wf-sidepane-button-closeall';

  const sidepaneActiveClassName = 'wf-sidepane-active';
  const sidepaneClosingClassName = 'wf-sidepane-closing';
  const sidepaneClosingDelay = 500;

  const sidepanes = document.querySelectorAll(sidepaneSelector);
  const sidepaneToggleButtons = document.querySelectorAll(sidepaneButtonToggleSelector);
  const sidepaneCloseButtons = document.querySelectorAll(sidepaneButtonCloseSelector);
  const sidepaneCloseAllButtons = document.querySelectorAll(sidepaneButtonCloseAllSelector);

  // Toggle target sidepane on toggle button click
  sidepaneToggleButtons.forEach(toggleButton => {
    toggleButton.addEventListener('click', event => {
      const targetSidepane = document.querySelector(toggleButton.dataset['wfSidepaneTarget']);

      if (targetSidepane) {
        const parentSidepaneGroup = targetSidepane.closest(sidepaneGroupSelector);

        // Ensure all other sidepanes in the group are closed
        if (parentSidepaneGroup) {
          parentSidepaneGroup.querySelectorAll(sidepaneSelector).forEach(sidepane => {
            if (sidepane !== targetSidepane) {
              closeSidepane(sidepane);
            }
          });
        }
  
        toggleSidepane(targetSidepane);
      }
    });
  });

  // Close parent sidepane on child close button click
  sidepaneCloseButtons.forEach(closeButton => {
    closeButton.addEventListener('click', event => {
      const parentSidepane = closeButton.closest(sidepaneSelector);
      closeSidepane(parentSidepane);
    });
  });

  // Close all sidepanes on close all button click
  sidepaneCloseAllButtons.forEach(closeAllButton => {
    closeAllButton.addEventListener('click', event => {
      sidepanes.forEach(sidepane =>
        { closeSidepane(sidepane); }
      );
    });
  });
  
  // Closes the specified sidepane
  function closeSidepane(sidepane) {
    if (sidepane.classList.contains(sidepaneActiveClassName)) {
      sidepane.classList.remove(sidepaneActiveClassName);
  
      sidepane.classList.add(sidepaneClosingClassName);
      setTimeout(function() {
        sidepane.classList.remove(sidepaneClosingClassName);
      }, sidepaneClosingDelay);
    }
  }

  // Opens the specified sidepane
  function openSidepane(sidepane) {
    sidepane.classList.add(sidepaneActiveClassName);
  }

  // Toggles the specified sidepane
  function toggleSidepane(sidepane) {
    if (sidepane.classList.contains(sidepaneActiveClassName)) {
      closeSidepane(sidepane);
    } else {
      openSidepane(sidepane);
    }
  }
}

initialize();